var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"loader"}},[_c('div',{staticClass:"lds-roller"},_vm._l((8),function(n){return _c('div',{key:n})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }